import request from '@/utils/request.js'
// 获取订单列表
export const goodsOrderList = mobile => {
  return request({
    method: 'GET',
    url: '/mopa/api-pay/open/weixin/native/order/list',
    params: {
      mobile
    }
  })
}
// 订单申请退款
export const orderRefund = outTradeNo => {
  return request({
    method: 'POST',
    url: '/mopa/api-pay/open/weixin/native/order/refund',
    data: {
      outTradeNo
    }
  })
}
